import { useState, useRef } from "react";

export const useTermo = () => {
  const [showTermoModal, setShowTermoModal] = useState(false);
  const [canAcceptTerm, setCanAcceptTerm] = useState(false);
  const termoRef = useRef(null);

  const handleTermoScroll = () => {
    if (termoRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = termoRef.current;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      setCanAcceptTerm(isAtBottom);
    }
  };

  const openTermoModal = () => {
    setShowTermoModal(true);
    setCanAcceptTerm(false);
  };

  const closeTermoModal = () => {
    setShowTermoModal(false);
    setCanAcceptTerm(false);
    if (termoRef.current) {
      termoRef.current.scrollTop = 0;
    }
  };

  const resetTermoScroll = () => {
    setCanAcceptTerm(false);
    if (termoRef.current) {
      termoRef.current.scrollTop = 0;
    }
  };

  return {
    showTermoModal,
    canAcceptTerm,
    termoRef,
    handleTermoScroll,
    openTermoModal,
    closeTermoModal,
    resetTermoScroll,
    setShowTermoModal,
    setCanAcceptTerm,
  };
};
